export class Address {
  public name: string;
  public street: string;
  public streetDescription?: string;
  public city: string;
  public state: string;
  public zipCode: string;
  public country: string;
}
